export default function viewportTriggers() {
  // inspector for midpoint or higher
  const isItemInMid = (el) => {
    const scroll = window.scrollY || window.pageYOffset;
    const boundsTop = el.getBoundingClientRect().top + scroll;

    const viewport = {
      top: scroll,
      bottom: scroll + window.innerHeight / 2,
    };

    const bounds = {
      top: boundsTop,
      bottom: boundsTop + el.clientHeight / 2,
    };

    return (bounds.bottom >= viewport.top && bounds.bottom <= viewport.bottom) || (bounds.top <= viewport.bottom && bounds.top >= viewport.top);
  };

  // requestAnimationFrame
  const raf =
    window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    function (callback) {
      window.setTimeout(callback, 1000 / 60);
    };

  function init() {
    const eles = Array.prototype.slice.call(document.querySelectorAll('.mid-trigger')); //Array.prototype for IE11 forEach support
    eles.forEach(function (ele) {
      const handler = () =>
        raf(() => {
          if (isItemInMid(ele)) {
            ele.classList.add('triggered');
            window.removeEventListener('scroll', handler); //just the once. clean up
          }
        });
      handler();
      window.addEventListener('scroll', handler);
    });
  }

  // attach inspector
  document.readyState !== 'loading'
    ? init()
    : document.addEventListener('DOMContentLoaded', () => {
        init();
      });
}
